export const STORE_URLS = {
  app_store: 'https://apps.apple.com/app/artefact/id6807840598',
  google_play: 'https://play.google.com/store/apps/details?id=com.artefact.mobile',
};

export const openStoreLink = (store) => {
  const url = STORE_URLS[store];
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
};
